import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomIconsEnum } from '../enums/custom-icons';

/**
 * Service being used for registering custom icons (Lemunzo-specific)
 */
@Injectable({
    providedIn: 'root',
})
export class CustomIconsService {
    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer
    ) {}

    /**
     * Initializes custom SVG icons by registering them with the Angular Material Icon Registry.
     * Icons are loaded from the specified directory path and sanitized for security.
     */
    public initializeCustomIcons(): void {
        Object.values(CustomIconsEnum).forEach((svgName) => {
            this.iconRegistry.addSvgIcon(
                svgName,
                this.sanitizeUrl(`assets/img/icons/lemunzo/${svgName}.svg`)
            );
        });
    }

    /**
     * Sanitizes a URL to create a SafeResourceUrl by bypassing Angular's security checks.
     *
     * @param url The URL to be sanitized.
     * @returns A SafeResourceUrl representing the sanitized URL that can be used in Angular templates.
     */
    private sanitizeUrl(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
